import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@glu/theming';
import Accordion from '@glu/accordion-react';
import Card from '../Card/Card';
import Color from '../../components/Color/Color';
import FontWeight from '../../components/FontWeight/FontWeight';
import StyleInput from '../../components/StyleInput/StyleInput';
import FontFamily from '../../components/FontFamily/FontFamily';
import ColorWithGradient from '../../components/ColorWithGradient/ColorWithGradient';

import styles from './Parts.styles';

const getComponent = type => {
  switch (type) {
    case 'fontWeight':
      return FontWeight;
    case 'pixel':
    case 'string':
      return StyleInput;
    case 'fontFamily':
      return FontFamily;
    case 'colorWithGradient':
      return ColorWithGradient;
    case 'color':
    default:
      return Color;
  }
};

const Parts = ({ parts, classes }) => {
  const spreadChildren = useCallback((children) => children.map((child) => {
    const { children: childChildren, ...rest } = child;
    if (!childChildren) {
      const Component = getComponent(rest.type);
      return <Component key={rest.name} {...rest} />;
    }
    return (
      <Accordion.Panel key={rest.name} className={classes.withBorder} panelId={rest.name}>
        <Accordion.Header className={`${classes.header} nested`} iconRight>{rest.labelText}</Accordion.Header>
        <Accordion.Content className={classes.innerContent}>
          {spreadChildren(childChildren, true)}
        </Accordion.Content>
      </Accordion.Panel>
    );
  }),
  [classes.withBorder, classes.header, classes.innerContent]);
  return parts.map((c) => (
    <Card key={`card-${c.labelText}`}>
      <Accordion className={classes.root}>
        <Accordion.Panel panelId={c.name}>
          <Accordion.Header className={classes.header} iconRight>{c.labelText}</Accordion.Header>
          <Accordion.Content className={classes.content}>
            {spreadChildren(c.children)}
          </Accordion.Content>
        </Accordion.Panel>
      </Accordion>
    </Card>
  ));
};

Parts.propTypes = {
  parts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired
};

export default withStyles(styles)(Parts);
